import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <div className="foot">
      <p>@2022 Jay Aggarwal. All Rights Reserved.</p>
    </div>
  );
};

export default Footer;
